import axios from 'axios';
import { call, put, select } from 'redux-saga/effects';
import { API } from '../constants/api';
import { methods } from '../constants/constants';
import { actions } from '../reducers/foros';
import { sagaNames, handleSagaError } from './index';

export const foroMateriasFromStore = state => state.foros.materias;
export const foroHilosFromStore = state => state.foros.hilos;
export const foroHilosMateriaIdFromStore = state => state.foros.hilosMateriaId;
export const foroHiloDetalleFromStore = state => state.foros.hiloDetalle;

function fetchMaterias() {
  return axios({
    method: methods.GET,
    url: API.FOROS.GET_MATERIAS,
  });
}

function fetchHilosMateria(idMateria, page, pageSize) {
  return axios({
    method: methods.GET,
    url: API.FOROS.GET_HILOS_MATERIA(idMateria),
    params: {
      page,
      pageSize,
    },
  });
}

function fetchHiloDetalle(idHilo) {
  return axios({
    method: methods.GET,
    url: API.FOROS.GET_HILO_DETALLE(idHilo),
  });
}

function postHiloData(idMateria, idPregunta, asunto, cuerpo) {
  return axios({
    method: methods.POST,
    url: API.FOROS.POST_HILO,
    data: {
      idMateria,
      idPregunta,
      asunto,
      cuerpo,
    },
  });
}

function postRespuestaData(idHilo, cuerpo) {
  return axios({
    method: methods.POST,
    url: API.FOROS.POST_RESPUESTA(idHilo),
    data: {
      cuerpo,
    },
  });
}

function deleteHiloData(idHilo) {
  return axios({
    method: methods.DELETE,
    url: API.FOROS.DELETE_HILO(idHilo),
  });
}

function deleteRespuestaData(idRespuesta) {
  return axios({
    method: methods.DELETE,
    url: API.FOROS.DELETE_RESPUESTA(idRespuesta),
  });
}

export function* getMaterias(args) {
  try {
    const materiasStore = yield select(foroMateriasFromStore);
    let materias = null;

    if (args.force || !Array.isArray(materiasStore) || materiasStore.length === 0) {
      const response = yield call(fetchMaterias);
      materias = response && response.data;
    } else {
      materias = materiasStore;
    }

    yield put(actions.successGetMaterias(materias));
  } catch (error) {
    const reducerFailureAction = actions.errorGetMaterias(error);
    yield handleSagaError(sagaNames.GET_FOROS_MATERIAS, error, reducerFailureAction);
  }
}

export function* getHilosMateria(args) {
  try {
    const hilosStore = yield select(foroHilosFromStore);
    const currentMateriaId = yield select(foroHilosMateriaIdFromStore);
    const samePage = hilosStore
      && hilosStore.page === args.page
      && hilosStore.pageSize === args.pageSize
      && currentMateriaId === args.idMateria;
    let hilos = null;

    if (args.force || !samePage || !Array.isArray(hilosStore?.items) || hilosStore.items.length === 0) {
      const response = yield call(fetchHilosMateria, args.idMateria, args.page, args.pageSize);
      hilos = response && response.data;
    } else {
      hilos = hilosStore;
    }

    yield put(actions.successGetHilosMateria(hilos));
  } catch (error) {
    const reducerFailureAction = actions.errorGetHilosMateria(error);
    yield handleSagaError(sagaNames.GET_FOROS_HILOS, error, reducerFailureAction);
  }
}

export function* getHiloDetalle(args) {
  try {
    const hiloDetalleStore = yield select(foroHiloDetalleFromStore);
    let hiloDetalle = null;

    if (args.force || !hiloDetalleStore || hiloDetalleStore.id !== args.idHilo) {
      const response = yield call(fetchHiloDetalle, args.idHilo);
      hiloDetalle = response && response.data;
    } else {
      hiloDetalle = hiloDetalleStore;
    }

    yield put(actions.successGetHiloDetalle(hiloDetalle));
  } catch (error) {
    const reducerFailureAction = actions.errorGetHiloDetalle(error);
    yield handleSagaError(sagaNames.GET_FORO_HILO_DETALLE, error, reducerFailureAction);
  }
}

export function* postHilo(args) {
  try {
    const response = yield call(postHiloData, args.idMateria, args.idPregunta, args.asunto, args.cuerpo);
    yield put(actions.successPostHilo(response));
    yield put(actions.getMaterias(true));
  } catch (error) {
    const reducerFailureAction = actions.errorPostHilo(error);
    yield handleSagaError(sagaNames.POST_FORO_HILO, error, reducerFailureAction);
  }
}

export function* postRespuesta(args) {
  try {
    const response = yield call(postRespuestaData, args.idHilo, args.cuerpo);
    yield put(actions.successPostRespuesta(response));
    yield put(actions.getHiloDetalle(args.idHilo, true));
  } catch (error) {
    const reducerFailureAction = actions.errorPostRespuesta(error);
    yield handleSagaError(sagaNames.POST_FORO_RESPUESTA, error, reducerFailureAction);
  }
}

export function* deleteHilo(args) {
  try {
    const response = yield call(deleteHiloData, args.idHilo);
    yield put(actions.successDeleteHilo(response));
    yield put(actions.getMaterias(true));

    if (args.idMateria) {
      yield put(actions.getHilosMateria(args.idMateria, args.page || 1, args.pageSize || 100, true));
    }
  } catch (error) {
    const reducerFailureAction = actions.errorDeleteHilo(error);
    yield handleSagaError(sagaNames.DELETE_FORO_HILO, error, reducerFailureAction);
  }
}

export function* deleteRespuesta(args) {
  try {
    const response = yield call(deleteRespuestaData, args.idRespuesta);
    yield put(actions.successDeleteRespuesta(response));

    if (args.idMateria) {
      yield put(actions.getHilosMateria(args.idMateria, args.page || 1, args.pageSize || 100, true));
    }
  } catch (error) {
    const reducerFailureAction = actions.errorDeleteRespuesta(error);
    yield handleSagaError(sagaNames.DELETE_FORO_RESPUESTA, error, reducerFailureAction);
  }
}
